import { render, staticRenderFns } from "./FilterBarPopularProvider.vue?vue&type=template&id=5c229e81&scoped=true"
import script from "./FilterBarPopularProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarPopularProvider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarPopularProvider.vue?vue&type=style&index=0&id=5c229e81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c229e81",
  null
  
)

export default component.exports